import { RootState } from '@/app/store';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, fetchBaseQuery } from '@reduxjs/toolkit/query';
import { getStorageItem } from '../helpers/storage';
import { TOKEN_COOKIE_NAMES } from './constants';

export const rawBaseQuery = (baseUrl) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers) => {
      await getStorageItem(TOKEN_COOKIE_NAMES['access']).then((token) => {
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
      });
      return headers;
    }
  });

export const baseApiQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const baseUrl = (api.getState() as RootState).config.apiBaseUrl;
  if (!baseUrl)
    return {
      error: {
        status: 400,
        statusText: 'Bad Request',
        data: 'No Base URL found'
      }
    };
  return rawBaseQuery(baseUrl)(args, api, extraOptions);
};
